export default {
  state: {
    shiftForm: {
      show: false,
      driver: null,
      gap: null,
      sector: null
    }
  },
  mutations: {
    setCoverageShiftFormShow (state, value) { state.shiftForm.show = value },
    setCoverageShiftFormDriver (state, value) { state.shiftForm.driver = value },
    setCoverageShiftFormGap (state, value) { state.shiftForm.gap = value },
    setCoverageShiftFormSector (state, value) { state.shiftForm.sector = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/coverage/coverage-shift-form.js